(function ($) {
    $(".boat-accordion-title-bar").on("click", function () {
        console.log('click accordion');
        $(this).closest('.boat-accordion').toggleClass('expand');
    });
    
    $(".charter-tab-slider-navigation--item").bind("click", function() {
        var slidx = $(this).attr('data-slide-index');
        $('.charter-tab-slider').slick('slickGoTo', slidx); 
    });

    $('.charter-tab-slider').on('init', function(event, slick){
        $("#charter-tab-slider-navigation--item-0").addClass('active');
    });

    $('.charter-tab-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(".charter-tab-slider-navigation--item").removeClass('active');
        $("#charter-tab-slider-navigation--item-" + nextSlide).addClass('active');
    });

    $(".charter-tab-slider").slick({
        prevArrow: '<i class="fa-solid fa-chevron-left slick-prev"></i>',
        nextArrow: '<i class="fa-solid fa-chevron-right slick-next"></i>',
        arrows: true,
        draggable:true,
        infinite: false,
        swipe: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1 ,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    arrows: false,
                  //  slidesToShow: 1.1,
        //slidesToScroll: 1 ,
        //infinite: true,
        //centerMode: true
                }
            }
        ]
    });

    $(".yachts-for-charter-slider").slick({
        prevArrow: '<i class="fa-solid fa-chevron-left slick-prev"></i>',
        nextArrow: '<i class="fa-solid fa-chevron-right slick-next"></i>',
        arrows: true,
        draggable: true,        
        infinite: true,
        swipe: true,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: true,
                    draggable: true,        
                    infinite: true,
                    swipe: true
                }
            },
            {
                breakpoint: 1600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  infinite: true,
                  dots: true,
                  arrows: true,
                  draggable: true,        
                  infinite: true,
                  swipe: true,
                }
              },
        ]
    }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
   });
})(jQuery);